import React from "react";
import ProfileCard from "pages/Profile/components/common/ProfileCard";
import { StarIcon } from "assets";

const SkillGroup = ({ title, items, favoriteIndex = -1 }) => (
  <div>
    <h3 className="mb-3 text-s uppercase tracking-wider dark:text-white">
      {title}
    </h3>
    <div className="flex flex-wrap gap-2">
      {items.map((item, i) => (
        <span
          key={i}
          className="flex items-center gap-1 rounded-lg border border-white/20 bg-white/15 px-3 py-1 text-xs font-medium"
        >
          {i === favoriteIndex && <StarIcon className="text-yellow-golden" />}
          {item}
        </span>
      ))}
    </div>
  </div>
);

interface Props {
  isEdit?: boolean;
}

const SkillsSection = ({ isEdit }: Props) => {
  return (
    <ProfileCard className="grid grid-cols-1 gap-4" isEdit={isEdit}>
      <SkillGroup
        title="Accents"
        items={["American Standard", "British RP", "New York", "Southern US"]}
        favoriteIndex={0}
      />
      <SkillGroup
        title="Performance"
        items={[
          "Stage Combat",
          "Period Movement",
          "Classical Acting",
          "Method Acting",
        ]}
      />
      <SkillGroup title="Presenting" items={["Live Events", "Voice Over"]} />
      <SkillGroup
        title="Music & Dance"
        items={["Ballet", "Jazz", "Tap", "Singing (Alto)"]}
      />
      <SkillGroup title="Sports" items={["Yoga", "Swimming", "Tennis"]} />
      <SkillGroup
        title="Other Skills"
        items={["Dialects", "Improvisation", "Piano"]}
      />
    </ProfileCard>
  );
};

export default SkillsSection;
